<div id="request-details">
    <div class="main_profile">
      <div class="modal-header switch_header">
        <ng-container>
          <div class="col-lg-12 col-xl-12 col-12">
            <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
              Request Details
            </h3>
          </div>
        </ng-container>
      </div>
      <div class="modal-body bg-white body-content">
        <ng-container>
          <div class=" details col-lg-12 col-md-12 px-sm-5 px-0 ">
            <div class="row  pt-lg-4">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Requested Date:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.requested_at ? (data.requested_at | dateonly:'MM/DD/yyyy') : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Completed:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.completed_at ? (data.completed_at | dateonly:'MM/DD/yyyy') : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Status:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.status }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Reason:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="breakword">{{ data.reason ? data.reason : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Note:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="note">{{ data.note ? data.note : '--' }}</label>
              </div>
            </div>
            <div class="row" *ngIf="data.upload_link">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Upload Link:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="breakword">
                  <a class="blue-link" [href]="data.upload_link" target="_blank">
                    {{ data.upload_link }}
                  </a>
                </label>
              </div>
            </div>

            <!-- PDT-32072 (AC-08): respond to a pended request — what Risk asked for + upload/note form -->
            <ng-container *ngIf="data.can_respond">
              <div class="row" *ngIf="data.pend_note">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                  <label class="">Requested Note:</label>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                  <label class="note breakword">{{ data.pend_note }}</label>
                </div>
              </div>
              <div class="row" *ngIf="data.pend_documents && data.pend_documents.length > 0">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                  <label class="">Requested Documents:</label>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                  <label class="breakword">{{ data.pend_documents.join(', ') }}</label>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-12">
                  <h5 class="mb-2">Submit Your Response</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textarea class="form-control" rows="3" placeholder="Add a note (optional when files are attached)"
                            [(ngModel)]="responseNote" [disabled]="submitting"></textarea>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-12">
                  <input #responseFileInput type="file" multiple hidden
                         accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.csv,.txt"
                         (change)="onFilesSelected($event)">
                  <button type="button" class="btn btn-outline-secondary" [disabled]="submitting"
                          (click)="responseFileInput.click()">
                    Attach Documents
                  </button>
                </div>
              </div>
              <div class="row" *ngIf="responseFiles.length > 0">
                <div class="col-12 pt-2">
                  <div *ngFor="let file of responseFiles; let i = index" class="d-flex align-items-center">
                    <label class="breakword mb-0">{{ file.name }}</label>
                    <button type="button" class="btn btn-link text-danger py-0" [disabled]="submitting"
                            (click)="removeFile(i)">Remove</button>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="responseError">
                <div class="col-12 pt-2">
                  <label class="text-danger breakword">{{ responseError }}</label>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="dropdown-footer">
      <div class="row justify-content-end">
        <button *ngIf="data.can_respond" class="btn btn-primary lg-btn mr-2"
                [disabled]="!canSubmit()" (click)="submitResponse()">
          {{ submitting ? 'Submitting...' : 'Submit Response' }}
        </button>
        <button class="btn btn-outline-secondary lg-btn ok-btn" (click)="closeAction()">
          Close
        </button>
      </div>
    </div>
</div>
